import { X } from 'lucide-react'
import pluralize from 'pluralize'

import type { BulkAction } from '@/components/bulk-actions-bar/types'
import { Button } from '@/components/lemmala-design-system/button/button'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

export type { BulkAction } from '@/components/bulk-actions-bar/types'

type BulkActionsBarProps = {
  selectedCount: number
  entityLabel: string
  actions: BulkAction[]
  onClose: () => void
  /** Appended after the count, e.g. "40 downloadable". */
  detail?: string
}

export const BulkActionsBar = ({
  selectedCount,
  entityLabel,
  actions,
  onClose,
  detail,
}: BulkActionsBarProps) => {
  return (
    <div className='fixed bottom-8 left-1/2 z-50 inline-flex -translate-x-1/2 items-center rounded-md border border-main-border-default bg-main-background-card py-2 pl-4 pr-2 shadow-md'>
      <span className='mr-6 text-label-default'>
        {pluralize(entityLabel, selectedCount, true)} selected
        {detail && <span className='text-main-foreground-secondary'>, {detail}</span>}
      </span>
      {actions.map(({ id, label, onClick, icon }, index) => (
        <Button
          key={id ?? label}
          variant='outline'
          className={index === actions.length - 1 ? 'mr-4' : 'mr-2'}
          onClick={onClick}
        >
          {icon ? <TextWithIcon icon={icon} text={label} /> : label}
        </Button>
      ))}
      <Button variant='ghost' size='icon-sm' onClick={onClose}>
        <X className='size-4' />
      </Button>
    </div>
  )
}
